export default "__VITE_ASSET__osAx8_rP__"